import { render } from "./BlogListSkeleton.vue?vue&type=template&id=3c3ab454&scoped=true"
import script from "./BlogListSkeleton.vue?vue&type=script&lang=js"
export * from "./BlogListSkeleton.vue?vue&type=script&lang=js"

import "./BlogListSkeleton.vue?vue&type=style&index=0&id=3c3ab454&scoped=true&lang=css"

import exportComponent from "E:\\AStrick-Web\\vue-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c3ab454"]])

export default __exports__